import { atom } from "jotai";
import {
  AppConstants,
  DEFAULT_KOT_DELAY,
  PRINT_CONSTANT,
} from "../constants/AppConstants";

const products = atom([]);
const totalAddOnsListState = atom([]);
const allProducts = atom([]);
const storeLogo = atom("");
const printLogo = atom("");
const cart = atom([]);
const responsive = atom({
  width: window.innerWidth,
  height: window.innerHeight,
});
const orderId = atom("");
const selectedOrderType = atom("");
const noStockProducts = atom([]);
const gstData = atom({});
const configuration = atom({});
const selectedCounter = atom("");
const printerConfiguration = atom({
  vid: "",
  pid: "",
  macAddress: "",
  host: "",
  port: "",
});
const KOTPrinterConfiguration = atom({
  vid: "",
  pid: "",
  macAddress: "",
  host: "",
  port: "",
});
const ParcelPrinterConfiguration = atom({
  vid: "",
  pid: "",
  macAddress: "",
  host: "",
  port: "",
});
const printerOrderIdPrefixState = atom("");
const countersListState = atom([]);
const isLogoutState = atom(false);
const remoteUrlState = atom(AppConstants.DEFAULT_REMOTE_URL);
const alertDialogInformationState = atom({});

const retryWebSocket = atom(0);

const isSocketConnect = atom(false);

const isConnectedWebSocketAfterSomeTimesState = atom(false);

const isPaymentSuccessWebSocketState = atom(false);

const isPaymentFailureWebSocketState = atom(false);

const isPaymentTimeOutWebSocketState = atom(false);

const websocketPaymentTransactionIdState = atom("");

const websocketMerchantOrderIdState = atom("");

const merchantDetailsState = atom({});
const kotDelayGlobalState = atom(DEFAULT_KOT_DELAY);
export {
  cart,
  selectedOrderType,
  orderId,
  products,
  responsive,
  noStockProducts,
  allProducts,
  storeLogo,
  gstData,
  configuration,
  selectedCounter,
  printerConfiguration,
  countersListState,
  isLogoutState,
  remoteUrlState,
  totalAddOnsListState,
  alertDialogInformationState,
  printerOrderIdPrefixState,
  retryWebSocket,
  isSocketConnect,
  isConnectedWebSocketAfterSomeTimesState,
  isPaymentSuccessWebSocketState,
  isPaymentFailureWebSocketState,
  websocketPaymentTransactionIdState,
  isPaymentTimeOutWebSocketState,
  websocketMerchantOrderIdState,
  merchantDetailsState,
  KOTPrinterConfiguration,
  ParcelPrinterConfiguration,
  kotDelayGlobalState,
  printLogo,
};
